import apiService from './api';

class PropertyService {
  // Public: fetch an enabled property page config
  async getProperty(slug) {
    try {
      const data = await apiService.get(`/api/property/${slug}`, {
        allowUnauthorized: true,
        useCache: false,
      });
      return { success: true, data: data.property || null };
    } catch (error) {
      return { success: false, error: error.message, data: null };
    }
  }

  // Admin: list all property pages
  async adminList() {
    try {
      const data = await apiService.get('/api/property/admin/list', { useCache: false });
      return { success: true, data };
    } catch (error) {
      return { success: false, error: error.message, data: null };
    }
  }

  // Admin: create a property page
  async adminCreate(payload) {
    try {
      const data = await apiService.post('/api/property/admin', payload);
      return { success: true, data };
    } catch (error) {
      return { success: false, error: error.message, data: null };
    }
  }

  // Admin: update a property page (supports { enabled } toggle)
  async adminUpdate(id, payload) {
    try {
      const data = await apiService.put(`/api/property/admin/${id}`, payload);
      return { success: true, data };
    } catch (error) {
      return { success: false, error: error.message, data: null };
    }
  }

  // Admin: delete a property page
  async adminDelete(id) {
    try {
      await apiService.delete(`/api/property/admin/${id}`);
      return { success: true };
    } catch (error) {
      return { success: false, error: error.message };
    }
  }
}

export default new PropertyService();
